export default {
  accountSummary: '/myaccount',
  userStatus: '/user/status',
  validateUsername: '/user/validate',
  login: '/user/login',
  logout: '/logout',
  labels: '/labels',
  home: '/home',
};
